import Dashboard from "layouts/dashboard";
import SignIn from "layouts/authentication/sign-in";
import Icon from "@mui/material/Icon";
import DashboardIcon from '@mui/icons-material/Dashboard';
import Auth from "authRoutes";
// import Locations from "layouts/locations";
import InventoryIcon from '@mui/icons-material/Inventory';
import CategoryIcon from '@mui/icons-material/Category';
import Users from "pages/users";
import ChatPage from "pages/chat";
import SettingsIcon from '@mui/icons-material/Settings';
import BlogAction from "pages/blogs/blogAction";
import Single from "pages/single";
import PermMediaIcon from '@mui/icons-material/PermMedia';
import NotificationsIcon from "@mui/icons-material/Notifications";
import ReviewsIcon from '@mui/icons-material/Reviews';

import ApprovalIcon from '@mui/icons-material/Approval';
import SpaIcon from '@mui/icons-material/Spa';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import RedeemIcon from '@mui/icons-material/Redeem';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import PaletteIcon from '@mui/icons-material/Palette';
import AppsIcon from '@mui/icons-material/Apps';
import ImportContactsIcon from '@mui/icons-material/ImportContacts';
import StraightenIcon from '@mui/icons-material/Straighten';
import PinDropIcon from '@mui/icons-material/PinDrop';
import MoreTimeIcon from '@mui/icons-material/MoreTime';
import MedicationIcon from '@mui/icons-material/Medication';
import HealingIcon from '@mui/icons-material/Healing';
import BookOnlineIcon from '@mui/icons-material/BookOnline';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import TuneIcon from '@mui/icons-material/Tune';
import Controls from "pages/common/controls";
// madammmm g
import Categories from "pages/beauty-app/categories";
import SubCategories from "pages/beauty-app/sub-categories";
import SubCatServices from "pages/beauty-app/sub-cat-services";
import Packages from "pages/beauty-app/packages";
import ProfessionalCharges from "pages/beauty-app/professional-charges";
import AddPackage from "pages/beauty-app/packages/addPackage";
import Products from "pages/beauty-app/products";
import AddItem from "pages/beauty-app/products/addItem";
import Bookings from "pages/beauty-app/bookings";
import Beauticians from "pages/beauty-app/beauticians";
import ShopCategory from "pages/e-commerce/shopcategory";
import ShopSubCategory from "pages/e-commerce/shop-sub-cat";
import Brands from "pages/e-commerce/brands";
import Colors from "pages/e-commerce/colors";
import Size from "pages/e-commerce/size";
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import FoundationIcon from '@mui/icons-material/Foundation';
import NoteAddIcon from '@mui/icons-material/NoteAdd';

import ControlPointDuplicateIcon from '@mui/icons-material/ControlPointDuplicate';
import LocalPharmacyIcon from '@mui/icons-material/LocalPharmacy';

import ShopProducts from "pages/e-commerce/shop-products";
import AddProduct from "pages/e-commerce/shop-products/addproduct";
import AddBeautician from "pages/beauty-app/beauticians/addBeautician";
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import SubscriptionsIcon from '@mui/icons-material/Subscriptions';
import Locations from "pages/common/locations";
import AddLocation from "pages/common/locations/addLocation";
import UpdateBeautician from "pages/beauty-app/beauticians/updateBeautician";
import GridViewIcon from '@mui/icons-material/GridView';
import PeopleIcon from '@mui/icons-material/People';
import BeautyDashboard from "layouts/dashboard/beauty-dashboard";
import Timeslots from "pages/common/timeslots";
import AddTimeslot from "pages/common/timeslots/addTimeslots";
import EcommerceDashboard from "layouts/dashboard/ecommerceDashboard";
import WellnessDashboard from "layouts/dashboard/wellnessDashboard";
import SkinAnalysisDashboard from "layouts/dashboard/skinAnalysisDashboard";
import Orders from "pages/e-commerce/orders";
import Offers from "pages/common/offers";
import Doctors from "pages/wellness/doctors";
import Concerns from "pages/wellness/concerns";
import AddConcern from "pages/wellness/concerns/addConcern";
import AddDoctor from "pages/wellness/doctors/addDoctor";
import Clinics from "pages/wellness/clinics";
import AddClinic from "pages/wellness/clinics/addClinic";
import ViewDoctor from "pages/wellness/doctors/viewDoctor";
import ViewClinic from "pages/wellness/clinics/viewClinic";
import Staff from "pages/staff";
import AddStaff from "pages/staff/addStaff";
import SensorOccupiedIcon from '@mui/icons-material/SensorOccupied';
import TagFacesIcon from '@mui/icons-material/TagFaces';
import Scans from "pages/skin-ai/scans";
import MyProfile from "pages/common/my-profile";
import Consultations from "pages/wellness/consultations";
import Applications from "pages/beauty-app/applications";
import Home from "pages/cms/home";
import ServicePackages from "pages/beauty-app/service-packages";
import AddServicePackage from "pages/beauty-app/service-packages/addServicePackage";
import Testimonials from "pages/cms/testimonials";
import Blogs from "pages/cms/blogs";
import AddBlog from "pages/cms/blogs/addBlog";
import Media from "pages/cms/media";
import ServiceCoupons from "pages/coupons/services";
import EditLocation from "pages/common/locations/editLocation";
import Notification from "pages/notification/Notification";
import Alerts from "pages/alerts";
import ReportIssues from "pages/report-issues";
import AddOnStock from "pages/beauty-app/addOnStock";
import Subscriptions from "pages/beauty-app/subscriptions";
import AddPlan from "pages/beauty-app/subscriptions/addPlan";
import Inventory from "pages/beauty-app/beauticians/updateBeautician/inventory";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    // icon: <Icon fontSize="small">Dashboard</Icon>,
    icon: <DashboardIcon />,
    // route: "/dashboard",
    // component: <Auth><Dashboard /></Auth>,
    collapse: [
      {
        type: "collapse",
        name: "Overview",
        key: "overview",
        icon: <GridViewIcon />,
        route: "/dashboard/overview",
        component: <Auth><Dashboard /></Auth>,
      },
      {
        type: "collapse",
        name: "Beauty",
        key: "beauty",
        icon: <SpaIcon />,
        route: "/dashboard/beauty",
        component: <Auth><BeautyDashboard /></Auth>,
      },
      {
        type: "collapse",
        name: "E-commerce",
        key: "commerce",
        icon: <ShoppingCartIcon />,
        route: "/dashboard/e-commerce",
        component: <Auth><EcommerceDashboard /></Auth>,
      },
      {
        type: "collapse",
        name: "Wellness",
        key: "wellness",
        icon: <HealingIcon />,
        route: "/dashboard/wellness",
        component: <Auth><WellnessDashboard /></Auth>,
      },
      {
        type: "collapse",
        name: "Skin-Analysis",
        key: "skinanalysis",
        icon: <TagFacesIcon />,
        route: "/dashboard/skin-analysis",
        component: <Auth><SkinAnalysisDashboard /></Auth>,
      },


    ],
  },
  {
    type: "collapse",
    name: "Staff",
    key: "staff",
    icon: <AssignmentIndIcon />,
    route: "/staff",
    component: <Auth><Staff /></Auth>,
  },
  {
    type: "collapse",
    name: "Users",
    key: "users",
    icon: <PeopleIcon />,
    route: "/users",
    component: <Auth><Users /></Auth>,
  },
  {
    type: "collapse",
    name: "Beauty App",
    key: "beauty-app",
    icon: <SpaIcon />,
    collapse: [
      {
        type: "collapse",
        name: "Categories",
        key: "categories",
        icon: <CategoryIcon />,
        route: "/beauty-app/categories",
        component: <Categories />,
      },
      {
        type: "collapse",
        name: "Sub-Categories",
        key: "subcategories",
        icon: <CategoryIcon />,
        route: "/beauty-app/sub-categories",
        component: <SubCategories />,
      },
      {
        type: "collapse",
        name: "Sub Cat-services",
        key: "catservices",
        icon: <CategoryIcon />,
        route: "/beauty-app/sub-cat-services",
        component: <SubCatServices />,
      },
      {
        type: "collapse",
        name: "Services",
        key: "products",
        icon: <CategoryIcon />,
        route: "/beauty-app/products",
        component: <Products />,
      },
      {
        type: "collapse",
        name: "Packages",
        key: "packages",
        icon: <RedeemIcon />,
        route: "/beauty-app/packages",
        component: <Packages />,
      },
      {
        type: "collapse",
        name: "Service Packages",
        key: "service-packages",
        icon: <RedeemIcon />,
        route: "/beauty-app/service-packages",
        component: <ServicePackages />,
      },
      // {
      //   type: "collapse",
      //   name: "Add-ons",
      //   key: "addons",
      //   icon: <AddBoxIcon />,
      //   route: "/beauty-app/add-ons",
      //   // component: < />,
      // },
      // {
      //   type: "collapse",
      //   name: "Professional Charges",
      //   key: "professionalstaff",
      //   icon: <PeopleAltIcon />,
      //   route: "/beauty-app/professional-charges",
      //   component: <ProfessionalCharges />,
      // },
      {
        type: "collapse",
        name: "Bookings",
        key: "bookings",
        icon: <ImportContactsIcon />,
        route: "/beauty-app/bookings",
        component: <Bookings />,
      },
      {
        type: "collapse",
        name: "Beautician",
        key: "beautician",
        icon: <PeopleAltIcon />,
        route: "/beauty-app/beauticians",
        component: <Beauticians />,
      },
      {
        type: "collapse",
        name: "Add on Stock",
        key: "addonstock",
        icon: <InventoryIcon />,
        route: "/beauty-app/add-on-stock",
        component: <AddOnStock />,
      },
      {
        type: "collapse",
        name: "Subscriptions",
        key: "subscriptions",
        icon: <SubscriptionsIcon />,
        route: "/beauty-app/beautician-subscriptions",
        component: <Subscriptions />,
      },
      {
        type: "collapse",
        name: "Applications",
        key: "applications",
        icon: <ApprovalIcon />,
        route: "/beauty-app/applications",
        component: <Applications />,
      },
    ],

  },
  {
    type: "collapse",
    name: "E-Commerce",
    key: "e-commerce",
    icon: <ShoppingCartIcon />,
    collapse: [
      {
        type: "collapse",
        name: "Shop Categories",
        key: "shopcategories",
        icon: <CategoryIcon />,
        route: "/e-commerce/category",
        component: <Auth><ShopCategory /></Auth>,
      },
      {
        type: "collapse",
        name: "Sub Categories",
        key: "shopcategories",
        icon: <CategoryIcon />,
        route: "/e-commerce/sub-categories",
        component: <Auth><ShopSubCategory /></Auth>,
      },
      {
        type: "collapse",
        name: "Brands",
        key: "shopcategories",
        icon: <AppsIcon />,
        route: "/e-commerce/brands",
        component: <Auth> <Brands /></Auth>,
      },
      {
        type: "collapse",
        name: "Colors",
        key: "colors",
        icon: <PaletteIcon />,
        route: "/e-commerce/colors",
        component: <Auth> <Colors /></Auth>,
      },
      {
        type: "collapse",
        name: "Size",
        key: "size",
        icon: <StraightenIcon />,
        route: "/e-commerce/size",
        component: <Auth> <Size /></Auth>,
      },

      {
        type: "collapse",
        name: "Products",
        key: "products",
        icon: <InventoryIcon />,
        route: "/e-commerce/products",
        component: <Auth> <ShopProducts /></Auth>,
      },
      {
        type: "collapse",
        name: "Orders",
        key: "orders",
        icon: <ImportContactsIcon />,
        route: "/e-commerce/orders",
        component: <Orders />,
      },

    ],
  },
  {
    type: "collapse",
    name: "Skin-ai",
    key: "skin",
    icon: <TagFacesIcon />,
    collapse: [
      {
        type: "collapse",
        name: "Scans",
        key: "scans",
        icon: <SensorOccupiedIcon />,
        route: "/skin-ai/scans",
        component: <Scans />,
      }
    ]

  },

  {
    type: "collapse",
    name: "Wellness",
    key: "welness",
    icon: <HealingIcon />,
    collapse: [
      {
        type: "collapse",
        name: "Concerns",
        key: "concerns",
        icon: <ControlPointDuplicateIcon />,
        route: "/wellness/concerns",
        component: <Concerns />,
      },
      {
        type: "collapse",
        name: "Clinics",
        key: "clinics",
        icon: <LocalPharmacyIcon />,
        route: "/wellness/clinics",
        component: <Clinics />,
      },
      {
        type: "collapse",
        name: "Doctors",
        key: "doctors",
        icon: <MedicationIcon />,
        route: "/wellness/doctors",
        component: <Doctors />,
      },
      {
        type: "collapse",
        name: "Appointments",
        key: "appointments",
        icon: <BookOnlineIcon />,
        route: "/wellness/appointments",
        component: <Consultations />,
      },
    ]

  },
  {
    type: "collapse",
    name: "Settings",
    key: "settings",
    icon: <SettingsIcon />,
    collapse: [
      {
        type: "collapse",
        name: "Locations",
        key: "locations",
        icon: <PinDropIcon />,
        route: "/settings/locations",
        component: <Auth>  <Locations /></Auth>,
      },
      {
        type: "collapse",
        name: "Timeslots",
        key: "timeslots",
        icon: <MoreTimeIcon />,
        route: "/settings/timeslots",
        component: <Auth>  <Timeslots /></Auth>,
      },
      {
        type: "collapse",
        name: "Offers",
        key: "offer",
        icon: <LocalOfferIcon />,
        route: "/settings/offers",
        component: <Auth>  <Offers /></Auth>,
      },
      {
        type: "collapse",
        name: "Controls",
        key: "controls",
        icon: <TuneIcon />,
        route: "/settings/controls",
        component: <Auth><Controls /></Auth>,
      },
    ],
  },

  {
    type: "collapse",
    name: "CMS",
    key: "cms",
    icon: <ManageAccountsIcon />,
    collapse: [
      {
        type: "collapse",
        name: "Home",
        key: "home",
        icon: <FoundationIcon />,
        route: "/cms/home",
        component: <Auth>  <Home /></Auth>,
      },
      {
        type: "collapse",
        name: "Testimonials",
        key: "testimonials",
        icon: <ReviewsIcon />,
        route: "/cms/testimonials",
        component: <Auth>  <Testimonials /></Auth>,
      },
      {
        type: "collapse",
        name: "Blogs",
        key: "blogs",
        icon: <NoteAddIcon />,
        route: "/cms/blogs",
        component: <Auth>  <Blogs /></Auth>,
      },

      {
        type: "collapse",
        name: "Media Coverage",
        key: "meidacoverage",
        icon: <PermMediaIcon />,
        route: "/cms/media-coverage",
        component: <Auth>  <Media /></Auth>,
      },
    ],
  }, {
    type: "collapse",
    name: "Coupons",
    key: "coupons",
    icon: <RedeemIcon />,
    collapse: [
      {
        type: "collapse",
        name: "Service Coupons",
        key: "servicecoupons",
        icon: <RedeemIcon />,
        route: "/coupons/service-coupons",
        component: <Auth>  <ServiceCoupons /></Auth>,
      },
      {
        type: "collapse",
        name: "Product Coupons",
        key: "productcoupons",
        icon: <RedeemIcon />,
        route: "/coupons/product-coupons",
        component: <Auth>  <Media /></Auth>,
      },
    ],
  },
  {
    type: "function",
    key: "packageadd",
    route: "/beauty-app/packages/add-package",
    component: <Auth> <AddPackage /></Auth>,
  },

  {
    type: "function",
    key: "packageedit",
    route: "/beauty-app/packages/update-package/:id",
    component: <Auth> <AddPackage /></Auth>,
  },
  {
    type: "function",
    key: "servicepackageadd",
    route: "/beauty-app/service-packages/add-service-package",
    component: <Auth> <AddServicePackage /></Auth>,
  },

  {
    type: "function",
    key: "servicepackageedit",
    route: "/beauty-app/service-packages/update-service-package/:id",
    component: <Auth> <AddServicePackage /></Auth>,
  },

  {
    type: "function",
    key: "packageadd",
    route: "/beauty-app/products/add-item",
    component: <Auth>  <AddItem /></Auth>,
  },

  {
    type: "function",
    key: "packageedit",
    route: "/beauty-app/products/update-item/:id",
    component: <Auth>  <AddItem /></Auth>,
  },

  {
    type: "function",
    key: "productss",
    route: "/e-commerce/products/add-product",
    component: <Auth> <AddProduct /></Auth>,
  },

  {
    type: "function",
    key: "productss",
    route: "/e-commerce/products/update-product/:id",
    component: <Auth> <AddProduct /></Auth>,
  },

  {
    type: "function",
    key: "productss",
    route: "/beauty-app/beauticians/add-beautician",
    component: <Auth>  <AddBeautician /></Auth>,
  },

  {
    type: "function",
    key: "productss",
    route: "/beauty-app/beauticians/beautician/:id",
    component: <Auth> <UpdateBeautician /></Auth>,
  },

  {
    type: "function",
    key: "locations",
    route: "/settings/locations/update-location/:id",
    component: <Auth> <EditLocation /></Auth>,
  },
  {
    type: "function",
    key: "locations",
    route: "/settings/locations/add-location",
    component: <Auth> <AddLocation /></Auth>,
  },

  {
    type: "function",
    key: "timeslots",
    route: "/settings/timeslots/update-timeslots/:id/:locId",
    component: <Auth> <AddTimeslot /></Auth>,
  },
  {
    type: "function",
    key: "timeslots",
    route: "/settings/timeslots/add-timeslots",
    component: <Auth> <AddTimeslot /></Auth>,
  },

  {
    type: "function",
    key: "concernAdd",
    route: "/wellness/concerns/add-concern",
    component: <Auth> <AddConcern /></Auth>,
  },

  {
    type: "function",
    key: "concernAdd",
    route: "/wellness/concerns/update-concern/:id",
    component: <Auth> <AddConcern /></Auth>,
  },
  {
    type: "function",
    key: "doctorAdd",
    route: "/wellness/doctors/add-doctor",
    component: <Auth> <AddDoctor /></Auth>,
  },

  {
    type: "function",
    key: "doctorAdd",
    route: "/wellness/doctors/view-doctor/:id",
    component: <Auth> <ViewDoctor /></Auth>,
  },

  {
    type: "function",
    key: "clinicAdd",
    route: "/wellness/clinics/add-clinic",
    component: <Auth> <AddClinic /></Auth>,
  },

  {
    type: "function",
    key: "clinicAdd",
    route: "/wellness/clinics/view-clinic/:id",
    component: <Auth> <ViewClinic /></Auth>,
  },

  {
    type: "function",
    key: "myprofile",
    route: "/profile",
    component: <Auth><MyProfile /></Auth>,
  },

  {
    type: "function",
    key: "staffAdd",
    route: "/staff/add-staff",
    component: <Auth> <AddStaff /></Auth>,
  },
  {
    type: "function",
    key: "staffAdd",
    route: "/staff/update-staff/:id",
    component: <Auth> <AddStaff /></Auth>,
  },

  , {
    type: "function",
    name: "Logout",
    key: "log-out",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/authentication/sign-in",
    component: <SignIn />,
  },
  {
    type: "function",
    name: "Logout",
    key: "log-out",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/",
    component: <SignIn />,
  },

  {
    type: "function",
    key: "chat",
    route: "/products/chat/:email",
    component: <ChatPage />,
  },

  {
    type: "function",
    key: "blog",
    route: "/cms/blogs/update-blog/:id",
    component: <AddBlog />,
  },
  {
    type: "function",
    key: "blog",
    route: "/cms/blogs/add-blog",
    component: <AddBlog />,
  },

  {
    type: "function",
    key: "blog",
    route: "/cms/media-coverage/update/:id",
    component: <AddBlog />,
  },
  {
    type: "function",
    key: "blog",
    route: "/cms/media-coverage/add",
    component: <AddBlog />,
  },

  {
    type: "function",
    key: "addSubscriptions",
    route: "/beauty-app/subscriptions/add-plan",
    component: <Auth> <AddPlan /></Auth>,
  },

  {
    type: "function",
    key: "editSubscriptions",
    route: "/beauty-app/subscriptions/update-plan/:id",
    component: <Auth> <AddPlan /></Auth>,
  },
  {
    type: "function",
    key: "vednors",
    route: "/vendors/:id",
    component: <Single />,
  },

  {
    type: "function",
    key: "inventoryview",
    route: "/beauty-app/beauticians/inventory/:beauticianId",
    component: <Auth>  <Inventory /></Auth>,
  },

  {
    type: "collapse",
    name: "Report Issues",
    key: "report-issues",
    icon: <ReviewsIcon />,
    route: "/report-issues",
    component: <Auth><ReportIssues /></Auth>,
  },
  {
    type: "collapse",
    name: "Notification",
    key: "notification",
    icon: <NotificationsIcon />,
    route: "/notification",
    component: <Auth><Notification /></Auth>
  },
  {
    type: "collapse",
    name: "Alerts",
    key: "alerts",
    icon: <NotificationsIcon />,
    route: "/alerts",
    component: <Auth><Alerts /></Auth>
  }
];

export default routes;
